import { getShopPageList } from "api/shop"
import Color from "color"
import useUrl from "hooks/useUrl"
import { RuntimeConfigurationContext } from "libs/contexts"
import { ShopPageType } from "libs/enums"
import { useRouter } from "next/router"
import { isEmpty } from "rambdax"
import { useContext, useEffect, useState } from "react"
import Container from "./Container"

const ROW_MAX = 6
export enum PageOpenTypeEnum {
  BLANK = 1, // 新开页面
  SELF, // 当前页面打开
}
export enum PublishFlag {
  ONLINE = 1,
}

export function ShopModuleChannelPC({ item, shopData }) {
  const router = useRouter()
  const runtimeConfig = useContext(RuntimeConfigurationContext)
  const mallSite =
    runtimeConfig.find((item) => item.key === "mall-site")?.value ?? ""

  const [navList, setNavList] = useState([])
  const { getPublicUrl } = useUrl()

  const channelList = item.jsonConfig.rows?.sort(
    (a, b) => a.priority - b.priority,
  )
  const textColor = shopData?.navigationSetting?.jsonConfig?.navTabColor
    ? Color("#" + shopData?.navigationSetting?.jsonConfig?.navTabColor)
    : "inherit"
  const justifyContent =
    item?.jsonConfig?.rows?.length > ROW_MAX ? "flex-start" : "center"

  const handleClickItem = (record) => {
    let target = "_blank"
    if (record.pageInfo?.openType === PageOpenTypeEnum.SELF) {
      target = "_top"
    }

    if (record.pageInfo?.configType === ShopPageType.LINK) {
      if (!record?.linkUrl) {
        console.error("暂未配置跳转链接")
        return
      }
      window.open(record.linkUrl, target)
    } else {
      let url = ""
      const shopSysNo = record.pageInfo.shopSysNo || router.query.shopSysNo
      const pageSysNo = record.pageInfo.sysNo || router.query.pageSysNo

      switch (record.pageInfo?.type) {
        case 1: {
          url = `${mallSite}/pages/shop/pro/index/${shopSysNo}`
          break
        }
        case 2: {
          url = `${mallSite}/pages/shop/pro/profile/${shopSysNo}`
          break
        }
        default: {
          url = `${mallSite}/pages/shop/pro/p/${shopSysNo}?pageSysNo=${pageSysNo}`
        }
      }
      window.open(url, target)
    }
  }

  const getName = (record) => {
    if (record.pageInfo?.type === 1) {
      return "首页"
    }
    if (record.pageInfo?.type === 2) {
      return "企业档案"
    }
    return record.name
  }

  const getNavLink = async () => {
    const res = await getShopPageList({
      json: {
        shopSysNo:
          router.query.shopSysNo ||
          shopData.navigationSetting?.jsonConfigrows?.rows?.[0]?.shopSysNo,
      },
    })
    const list = channelList
      ?.map((v) => {
        const item = res.data?.find((c) => c.sysNo === v.pageSysNo)
        if (item && item.publishFlag === PublishFlag.ONLINE) {
          return {
            ...v,
            openType: item.openType,
            name: item.name,
            linkUrl: item.linkUrl ? item.linkUrl : v.linkUrl,
          }
        } else {
          return null
        }
      })
      ?.filter((v) => v)
    setNavList(list)
  }

  useEffect(() => {
    getNavLink()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isEmpty(item?.jsonConfig) || isEmpty(item?.jsonConfig?.rows)) {
    return null
  }

  return (
    <>
      <div className="channel-wrap">
        <Container>
          <div className="channel-ul">
            {navList.map((item, index) => (
              <div
                key={index}
                className="channel-li"
                onClick={() => handleClickItem(item)}
              >
                <div className="page-icon">
                  <img alt="" src={getPublicUrl(item.pageIcon)} />
                </div>
                <div className="page-name">{getName(item)}</div>
              </div>
            ))}
          </div>
        </Container>
      </div>
      <style jsx>{`
        .channel-wrap {
          padding: 35px 0 0 0;
          background-color: #fff;
        }

        .channel-ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: ${justifyContent};
          align-items: center;
        }

        .channel-li {
          width: 200px;
          flex: 0 0 200px;
          margin-bottom: 35px;
        }

        .page-icon {
          width: 114px;
          height: 114px;
          margin: 0 auto;
          margin-bottom: 15px;
          overflow: hidden;
          cursor: pointer;
        }

        .page-icon img {
          width: 100%;
          height: 100%;
        }

        .page-name {
          font-size: 22px;
          color: ${textColor};
          text-align: center;
          line-height: 22px;
          cursor: pointer;
        }
      `}</style>
    </>
  )
}
